module.exports = __webpack_public_path__ + "img/icon-evening.e2c1406a.png";